export var AfriexMessageChannel;
(function (AfriexMessageChannel) {
    AfriexMessageChannel["Sms"] = "sms";
    AfriexMessageChannel["Whatsapp"] = "whatsapp";
    AfriexMessageChannel["Email"] = "email";
    AfriexMessageChannel["Push"] = "push";
    AfriexMessageChannel["Voice"] = "voice";
})(AfriexMessageChannel || (AfriexMessageChannel = {}));
//# sourceMappingURL=AfriexMessageChannel.js.map